export default {
  title: 'Modes de commande',
  paywall: {
    live_title: '{{name}} est en ligne !',
  },
  tabs: {
    general: 'Général',
    pickup: 'À emporter',
    delivery: 'Livraison',
    table_ordering: 'Commande à table',
  },
  modals: {
    update_confirmation: {
      title: 'Voulez-vous enregistrer les nouvelles modifications ?',
      buttons: {
        confirm: 'Confirmer',
        cancel: 'Annuler',
      },
    },
    switch_live_orders: {
      titles: {
        disable: 'Voulez-vous désactiver les commandes en direct ?',
        enable: 'Voulez-vous activer les commandes en direct ?',
      },
      buttons: {
        yes: 'Oui',
        no: 'Non',
      },
    },
  },
  toasts: {
    failed_to_save_changes: "Échec de l'enregistrement",
    changes_got_saved: 'Modifications enregistrées',
    table_ordering_saved: 'Commande à table enregistrée',
  },
};
